/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetProcessingStepsQueryResponse, DocumentUseCasesControllerGetProcessingStepsPathParams, DocumentUseCasesControllerGetProcessingSteps401, DocumentUseCasesControllerGetProcessingSteps403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetProcessingSteps";

function getDocumentUseCasesControllerGetProcessingStepsUrl(processingId: DocumentUseCasesControllerGetProcessingStepsPathParams["processingId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/processings/${processingId}/steps` as const }  
  return res
}

/**
 * @description Returns all steps for a processing job with their statuses and key metadata as a JSON:API array.
 * @summary Get all steps for a processing workflow
 * {@link /api/v1/documents/processings/:processingId/steps}
 */
export async function documentUseCasesControllerGetProcessingSteps(processingId: DocumentUseCasesControllerGetProcessingStepsPathParams["processingId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerGetProcessingStepsQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetProcessingSteps401 | DocumentUseCasesControllerGetProcessingSteps403>, unknown>({ method : "GET", url : getDocumentUseCasesControllerGetProcessingStepsUrl(processingId).url.toString(), ... requestConfig })  
  return res.data
}